import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import ProjectTableDto from '../dto/ProjectTableDto';

class ProjectTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'projectTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<ProjectTableDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, ProjectTableDto)))
				.catch(reject);
		});
	}
}

export default new ProjectTableService();
